function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Row, Col, Button } from 'reactstrap';
import Icon from "../../../common/icon";
import TranslateObj from "../../../common/translation-object";
export default (function (_ref) {
  var id = _ref.id,
    index = _ref.index,
    element = _ref.element,
    onDelete = _ref.onDelete;
  return /*#__PURE__*/React.createElement(Draggable, {
    key: id,
    draggableId: "elementdnd_".concat(id),
    index: index
  }, function (provided) {
    return /*#__PURE__*/React.createElement("li", _extends({
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps, {
      className: "collectorDndListElement"
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: "3",
      sm: "4",
      className: "text-left"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "bars"
    }), "\xA0\xA0\xA0", /*#__PURE__*/React.createElement("span", {
      className: "text-primary"
    }, index)), /*#__PURE__*/React.createElement(Col, null, element.icon ? /*#__PURE__*/React.createElement(Icon, {
      name: element.icon
    }) : '', "\xA0", /*#__PURE__*/React.createElement(TranslateObj, {
      from: element.name
    })), /*#__PURE__*/React.createElement(Col, {
      sm: "3",
      className: "text-right"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "default",
      onClick: onDelete
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "minus-circle"
    })))));
  });
});